import { Tag } from '@chakra-ui/react';

/**
 * A reusable hook to parse backticks in a string and replace them with styled Tag components.
 *
 * @param text - The input string containing backticks.
 * @returns A React node with backticks replaced by Tag components.
 */
export const useParseBackticks = () => {
  const parseBackticks = (text: string): React.ReactNode => {
    const parts = text.split(/(`[^`]+`)/g); // Split by backticks

    return parts.map((part: string, index: number) => {
      if (part.startsWith('`') && part.endsWith('`')) {
        const contents = part.slice(1, -1); // Extract contents inside backticks

        return (
          <Tag
            data-testid={`code-tag${part}`}
            key={index}
            variant="subtle"
            colorScheme="gray"
            display={'inline-block'}
            verticalAlign={'baseline'}
            m={'2px'}
            p={'5px 10px 0px 10px'}
          >
            {contents}
          </Tag>
        );
      }
      return part;
    });
  };

  return { parseBackticks };
};
